import $ from 'jquery';
import _ from 'lodash';
// import 'slick-carousel'
import PostSlick from '../modules/post_carousel';

export default {
  init() {
    // console.log('common');
  },
  finalize() {
    AnimatedText.init();
    PostSlick('.community .posts');
    // console.log
    PostSlick('.events .posts');
    FeaturedModule.init();
  },
};

var FeaturedModule = ( () =>  {
  var self = {};

  const $module = $("#feature"),
        $close = $("#feature .close"),
        displayTrigger = 1000;

  self.init = () => {
    /* No feature */
    if($module.length == 0) {
      return;
    }

    window.addEventListener('scroll', _.throttle(self.showHide, 400) );
    $close.click( self.close );
    self.showHide();
  };

  self.showHide = () => {
    var scroll = $(window).scrollTop();
    if(scroll > displayTrigger) {
      $module.removeClass('hidden');
    }
  };

  self.close = (e) => {
    e.stopPropagation();
    $module.addClass('dismissed');
    return false;
  };

  return self;
})();


var AnimatedText = ( () => {
  var self = {};

  const $animatedText = $("h1.animated-header"),
        sentences = [
          "Fit Pregnancy Club",
          "Fit Pregnancy Counts",
          "Fit Pregnancy Classes",
          "Fit Pregnancy Challenge",
          "Fit Pregnancy Community"
        ],
        speed = 1000;

  var index = 0;

  self.init = () => {
    self.update();
    window.setInterval(self.update, 1000);
  };

  self.update = () => {
    $animatedText.text(sentences[index]);
    index = (index + 1) % sentences.length;
  };

  return self;
})();
